import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';

const GenericSelection = props => {
  const inputClass = classNames(props.className, "selection-dropdown");
  return (
    <div style={{ ...props.containerStyle }}>
      <label htmlFor="selection" className="control-label">
        <span className="selection-label" style={{ ...props.labelStyle }}>{ props.translation }{(props.colon) ? ':' : ''}</span>
        <Select
          id="selection"
          className={inputClass}
          clearable={false}
          value={props.value}
          options={props.options}
          onChange={(e) => { props.setSelected(e); }}
          disabled={props.disabled}
        />
      </label>
    </div>
  )
}

GenericSelection.defaultProps = {
  translation: '',
  disabled: false,
  colon: false,
  containerStyle: {},
  labelStyle: {},
};

GenericSelection.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.shape({}).isRequired,
  setSelected: PropTypes.func.isRequired,
  translation: PropTypes.node,
  disabled: PropTypes.bool,
  colon: PropTypes.bool,
  containerStyle: PropTypes.object,
};

export default GenericSelection;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/GenericSelection.jsx